import { Colaborador } from '@/store/catalogos/colaborador';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { ProveedorModel } from '@/store/catalogos/proveedor';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormularioDepartamentoComponent } from '@modules/catalogos/departamentos/formulario-departamento/formulario-departamento.component';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { CatalogoProveedorService } from '@services/catalogo/catalogoProveedor.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';
import { properties } from '@/utils/properties';
@Component({
  selector: 'app-formulario-proveedor',
  templateUrl: './formulario-proveedor.component.html',
  styleUrls: ['./formulario-proveedor.component.scss']
})
export class FormularioProveedorComponent {

  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nuevo Proveedor";


  constructor(
    private util: Util,
    private datePipe: DatePipe,
    private catalogoService: CatalogoProveedorService,
    public dialogRef: MatDialogRef<FormularioProveedorComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Proveedor";
    }
    if (data.view) {
      this.title = "Vista Proveedor";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);

  }

  private buildForm(data: ProveedorModel): void {
    this.form = new FormGroup({
      idProveedor: new FormControl(data?.idProveedor ?? null),
      nombre: new FormControl(data?.nombre ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      rfc: new FormControl(data?.rfc ?? '', {
        nonNullable: true,
        validators: [Validators.required,Validators.required, Validators.maxLength(13)]
      }),
      telefono: new FormControl(data?.telefono ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      fax: new FormControl(data?.fax?? '', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }

 
  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const proveedor: ProveedorModel = this.formToModel();
    const request = this.data.insert
      ? this.catalogoService.create(proveedor)
      : this.catalogoService.update(proveedor);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): ProveedorModel {
    const formValues = this.form.getRawValue();

    return {
      idProveedor: formValues.idProveedor ?? '',
      nombre: formValues.nombre ?? '',
      rfc: formValues.rfc ?? '',
      telefono: formValues.telefono ?? '',
      fax: formValues.fax ?? '',
      colaborador: {
        idColaborador: properties.ID_USUARIO
      }
    };
  }
}
